
/**
 * Throws an error if the condition is false.
 * @param {boolean} condition
 * @param {string} message
 */
export function assert(condition, message = "Assertion failed") {
  if (!condition) throw new Error(message);
}

/**
 * Check that the provided value is a non-empty object.
 * @param {object} obj
 * @param {string} [message]
 */
export function assertNonEmptyObject(obj, message = "Request body is required and must be a non-empty object.") {
  const isObject = obj && typeof obj === "object" && !Array.isArray(obj);
  const hasKeys = isObject && Object.keys(obj).length > 0;
  assert(isObject && hasKeys, message);
}
